import { toLower } from "lodash";
import React from "react";
import { Form } from "react-bootstrap";

import { FormControl } from "../../";

const FieldInput = ({ field, form, className = "", ...rest }) => {
  const {
    preventSpecialCharacter = false,
    onlyNumbersAndHyphen = false,
    forMapper = false,
    isCensusPayrollError = false,
  } = rest;
  let format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
  let numPadNumberKeyCodes = [
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
  ];
  var invalidChars = ["-", "+", "e", "E"];
  let autoCompleteAttr = {
    autoComplete: "off",
  };
  if (["name", "firstName", "lastName", "middleName"].includes(field.name)) {
    autoCompleteAttr = {
      autoComplete: "new-name",
    };
  }
  if (rest.type === "password") {
    autoCompleteAttr = {
      autoComplete: "new-password",
    };
  }
  if (field.name === "email") {
    autoCompleteAttr = {
      autoComplete: "new-email",
    };
  }

  if (
    toLower(field.name).indexOf("postal") !== -1 ||
    toLower(field.name).indexOf("zip") !== -1
  ) {
    autoCompleteAttr = {
      autoComplete: "new-zip",
    };
  }
  return (
    <FormControl
      {...field}
      {...form}
      {...rest}
      isCensusPayrollError={isCensusPayrollError}
    >
      <Form.Control
        onKeyDown={(event) => {
          if (
            (preventSpecialCharacter && event.key.match(format)) ||
            (onlyNumbersAndHyphen &&
              numPadNumberKeyCodes.includes(event.keyCode)) ||
            (rest.type == "number" && invalidChars.includes(event.key))
          ) {
            event.preventDefault();
          }
        }}
        {...field}
        {...rest}
        {...autoCompleteAttr}
        className={forMapper ? "container-size" : className}
      />
    </FormControl>
  );
};

export default FieldInput;
